import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledWrapper = styled.hr`
  height: ${rem('1px')};
  margin: 0;
  border: none;
  background-color: ${({ theme }) => theme.colors.cross.silverFox};
`;
